import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  faApple
} from "@fortawesome/free-brands-svg-icons";
import faGoogle from "../Assests/Google.png";
import faFacebook from "../Assests/Facebook.png";
import "./Pages.css";
import logo from "./../Assests/Rectangle 36.png";
import arrowSignup from "../Assests/Vector 4.png";
import { useNavigate } from "react-router-dom";
import {
  signInWithTOTP,
  isAuthenticated,
  AuthService,
  confirmPassword,
  forgotPassword,
  requestotp,
  resetPassword,
  getUserDetails,
  getCognitoUserMfaMethod,
  signInTOTP,
  signInWithEmail,
  verifyEmailOTP,
} from "../Services/AuthService";
import ErrorModal from "../Components/ErrorModal";
import { useSnackbar } from "../Components/SnackbarContext";
import { useGoogleLogin } from "@react-oauth/google";
import { emailValidation, getUserProfileDetails } from "../Services/ShowsApi";
import { CometChat } from "@cometchat/chat-sdk-javascript";
import axios from "axios";
import { CometChatUIKit } from "@cometchat/chat-uikit-react";
import { updateProfilePicture } from "../utils/CometChatCommon";
import { useAuth } from "../Routes/AuthContext";
import { FormControl, FormLabel} from '@mui/material';
import LogoWithGradient from '../Components/LogoWithGradient/LogoWithGradient';
import LogoAnimation from "../Components/LogoAnimation";
import { buttonStyles, inputFieldStyles, forgotPasswordFieldStyles } from "../utils/constant";

const dyrectApi = process.env.REACT_APP_DYRECT_API_URL;


function Login() {
  const { login  } = useAuth();

  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [popup, setPopup] = useState({ open: false, title: "", message: "" });
  const handlePopupClose = () =>
    setPopup({ open: false, title: "", message: "" });
  const [totpCode, setTotpCode] = useState("");
  const [showTOTP, setShowTOTP] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [activeButton, setActiveButton] = useState(false);
  const [challengeResponse, setChallengeResponse] = useState(null);
  const [signInResponse, setSignInResponse] = useState(null);

  const navigate = useNavigate();
  const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN; // Replace with your Cognito domain
  const clientId = process.env.REACT_APP_CLIENT_ID;
  const redirectUri = "http://localhost:3000/login"; // Set this to your login page's callback URL
  const googleProvider = "Google";
  const { triggerSnackbar } = useSnackbar();
  const [forgotPasswordPopup, setForgotPasswordPopup] = useState({
    open: false,
    stage: 1, // Stage 1: Request Code, Stage 2: Reset Password
    username: "",
    verificationCode: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [cognitoUser, setCognitoUser] = useState(null);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const navigateToHome = async (event) => {
    const response = await getUserProfileDetails("UserID");

    console.log("response", response)
    console.log("LoginUserId", localStorage.getItem("user_id"))
    const userId = localStorage.getItem("user_id");
    
    const userData = response?.data?.body?.Data?.[0];
    
    if (userData) {
      localStorage.setItem('user_profile_data', JSON.stringify(userData));
      localStorage.setItem('isAdmin', userData.IsAdmin ? 'true' : 'false');
      if (userData.ProfileImageKey) {
        localStorage.setItem('user_profile_img', userData.ProfileImageKey);
      }
    }

    try {
      // Initialize CometChat first
      const appId = process.env.REACT_APP_COMETCHAT_APP_ID;
      const region = process.env.REACT_APP_COMETCHAT_APP_REGION;
      const authKey = process.env.REACT_APP_COMETCHAT_AUTH_KEY;
      
      const appSettings = new CometChat.AppSettingsBuilder()
        .subscribePresenceForAllUsers()
        .setRegion(region)
        .build();
      
      try {
        await CometChat.init(appId, appSettings);
        console.log("CometChat initialized successfully");
      } catch (initError) {
        if (initError.code !== 'ALREADY_INITIALIZED') {
          console.error("CometChat initialization failed:", initError);
          throw initError;
        }
        console.log("CometChat already initialized");
      }
      
      // Check if already logged in and login if needed
      let loggedInUser = await CometChat.getLoggedinUser();
      if (!loggedInUser) {
        loggedInUser = await CometChat.login(userId, authKey);
        console.log("CometChat login successful:", loggedInUser);
      }

      // Only update profile picture if user is logged in and has profile image
      if (loggedInUser && response?.data?.body?.Data[0]?.ProfileImageKey) {
        const base64Image = await urlToBase64(response?.data?.body?.Data[0]?.ProfileImageKey);
        await updateProfilePicture(base64Image);
      }
    } catch (error) {
      console.error("Error logging into CometChat or updating avatar:", error);
    }

    // let responsecometchatlog =await CometChatUIKit.login(localStorage.getItem("user_id"));
    // console.log("responsecometchatlog", responsecometchatlog)

    // const base64Image = await urlToBase64(response?.data?.body?.Data[0]?.ProfileImageKey);
    // updateProfilePicture(base64Image);
    if (response?.data?.body?.Data[0]?.IsProfileCompleted === 1) {
      // navigate("/home");
      navigate('/shows', { replace: true });

    } else {
      navigate('/information', { replace: true });

    }
  };

  async function urlToBase64(url) {
    const response = await fetch(url);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // gives base64 string with data:image/... prefix
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }


  const handleLogin = async () => {
    try {
      if (showTOTP) {
        console.log("Attempting TOTP verification", cognitoUser);
        await signInWithTOTP(cognitoUser, totpCode);
        navigateToHome();
        // navigate("/home");
      } else {
        console.log("Starting login process...");
        const result = await signInWithEmail(email, password);
        console.log("Login result:", result);

        if (result.userConfirmationNecessary) {
          console.log("Setting sign-in response:", result.signInResponse);
          setSignInResponse(result.signInResponse);
          setUsername(result.username);
          setShowTOTP(true);
        }
      }
    } catch (err) {
      console.error("Login error:", err);
      setPopup({
        open: true,
        message: "Login failed. Please check your credentials and try again.",
      });
    }
  };

  const handleVerifyOTP = async () => {
    try {
      console.log("signInResponse", signInResponse);
      setActiveButton(true)
      if (!signInResponse) {
        console.error("No sign-in response available");
        setPopup({
          open: true,
          message: "Authentication error. Please try logging in again.",
        });
        return;
      }

      if (!totpCode || totpCode.length !== 6) {
        setPopup({
          open: true,
          message: "Please enter a valid 6-digit verification code.",
        });
        return;
      }

      console.log("Verifying Email OTP...");
      const verificationResult = await verifyEmailOTP(totpCode, signInResponse);

      console.log("username....", username);
      if (verificationResult.success) {
        console.log("OTP verified successfully");
        const userDetails = await getUserProfileDetails("UserName", username);
        console.log("userDetails: ", userDetails);
        console.log(userDetails?.data?.body?.Data[0]?.UserID);
        localStorage.setItem(
          "user_id",
          userDetails?.data?.body?.Data[0]?.UserID
        );

        login();
        await navigateToHome();

      } else {
        setPopup({
          open: true,
          message: "Invalid verification code. Please try again.",
        });
      }
    } catch (err) {
      console.error("OTP verification error:", err);
      setPopup({
        open: true,
        message:
          "An error occurred while verifying the OTP. Please try again later.",
      });
    } finally {
      setActiveButton(false); // always reset
    }
  };

  const handleSignInError = (err) => {
    console.error("Authentication error:", err);

    const errorMessages = {
      NotAuthorizedException:
        "Incorrect username or password. Please try again.",
      UserNotFoundException:
        "User does not exist. Please check your email and try again.",
      CodeMismatchException:
        "The verification code you entered is incorrect. Please double-check it and try again.",
      default: "An error occurred during login. Please try again later.",
    };

    setPopup({
      open: true,
      message: errorMessages[err.code] || errorMessages.default,
    });
  };

  const handleGoogleLogin = useGoogleLogin({
    flow: "popup",
    onSuccess: async (tokenResponse) => {
      console.log("Token Response:", tokenResponse);
      try {
        const access_token = await exchangeGoogleCodeForToken(
          tokenResponse?.code
        );
        const userInfo = await fetchGoogleUserInfo(access_token);
        console.log("userInfobbbbbbbbbbbbbbbbb", userInfo)
        if (userInfo?.email === undefined) {
          setPopup({
            open: true,
            message: "Unable to retrieve the email. Please try again.",
          });
          return;
        }
        const doesEmailExist = await emailValidation(userInfo?.email);
        console.log("doesEmailExist", doesEmailExist)
        if (doesEmailExist?.data?.response === "exist") {
          const userDetails = await getUserProfileDetails(
            "Email",
            userInfo?.email
          );
          console.log("userDetails: ", userDetails);
          console.log(userDetails?.data?.body?.Data[0]?.UserID);
          localStorage.setItem(
            "user_id",
            userDetails?.data?.body?.Data[0]?.UserID
          );
          login();
          navigateToHome();
          // navigate("/home");
        } else {
          setPopup({
            open: true,
            message:
              "No account was found. Please sign up before attempting to log in.",
          });
          return;
        }
      } catch (error) {
        console.error("Handle Google Sign up failure:", error);
        setPopup({
          open: true,
          message: error?.message ? error.message : "Unable to Create the User",
        });
      }
    },
    onError: (error) => {
      console.error("Google Login Failed:", error);
    },
  });

  const exchangeGoogleCodeForToken = async (authorizationCode) => {
    const tokenUrl = process.env.REACT_APP_GOOGLE_TOKEN_URL;

    const body = new URLSearchParams({
      code: authorizationCode,
      client_id: process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID,
      client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
      redirectUri: process.env.REACT_APP_GOOGLE_REDIRECT_URL,
      grant_type: "authorization_code",
    });

    try {
      const response = await fetch(tokenUrl, {
        method: "POST",
        body: body,
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });

      const data = await response.json();

      if (response.ok) {
        console.log("Access Token:", data.access_token);
        console.log("ID Token:", data.id_token); // Optional: You can use the id_token to get user info
        return data.access_token; // You can use this token to make authenticated API requests
      } else {
        throw new Error("Failed to exchange code for access token");
      }
    } catch (error) {
      console.error("Error exchanging code for token:", error);
    }
  };

  const fetchGoogleUserInfo = async (accessToken) => {
    const userInfoUrl = process.env.REACT_APP_GOOGLE_USER_INFO_URL;

    try {
      const response = await fetch(userInfoUrl, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const userInfo = await response.json();
      console.log("User Info:", userInfo);
      return userInfo;
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  const handleFacebookLogin = () => {
    window.FB.getLoginStatus((response) => {
      if (response.status === "connected") {
        console.log("User already signed in. Logging out first...");
        window.FB.logout(() => {
          console.log("Logged out. Now showing sign-up popup...");
          openFacebookLogin();
        });
      } else {
        openFacebookLogin();
      }
    });
  };

  const openFacebookLogin = () => {
    window.FB.login(
      function (response) {
        if (response.authResponse) {
          console.log("Sign-up successful! Fetching user data...");
          fetchFacebookUser();
        } else {
          console.log("User cancelled sign-up. Logging out...");
          window.FB.logout(); // 🔥 Logs out to prevent auto-login if user closes popup
        }
      },
      {
        scope: "email,public_profile",
        auth_type: "reauthenticate",
        display: "popup",
      }
    );
  };

  const fetchFacebookUser = () => {
    window.FB.api(
      "/me",
      { fields: "email,first_name,last_name" },
      async function (user) {
        console.log("User data received:", user);

        if (!user?.email) {
          console.error("Unable to retrieve the email. Logging out...");
          window.FB.logout(); // 🔥 Logs out to prevent auto-login with partial data
          setPopup({
            open: true,
            message: "Unable to retrieve the email. Please try again.",
          });
          return;
        }

        const doesEmailExist = await emailValidation(user?.email);
        if (doesEmailExist?.data?.response === "exist") {
          const userDetails = await getUserProfileDetails("Email", user?.email);
          console.log("userDetails: ", userDetails);
          console.log(userDetails?.data?.body?.Data[0]?.UserID);
          localStorage.setItem(
            "user_id",
            userDetails?.data?.body?.Data[0]?.UserID
          );
          navigateToHome();
          // navigate("/home");
        } else {
          setPopup({
            open: true,
            message:
              "No account was found. Please sign up before attempting to log in.",
          });
          return;
        }
      }
    );
  };

  const handleForgotPassword = async () => {
    try {
      await requestotp(forgotPasswordPopup.username);
      setForgotPasswordPopup((prev) => ({ ...prev, stage: 2 }));
      setErrorMessage("");
    } catch (error) {
      setErrorMessage("Failed to send verification code.");
    }
  };

  const handleResetPassword = async () => {
    if (
      forgotPasswordPopup.newPassword !== forgotPasswordPopup.confirmPassword
    ) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    try {
      await resetPassword(
        forgotPasswordPopup.username,
        forgotPasswordPopup.verificationCode,
        forgotPasswordPopup.newPassword
      );
      setShowSuccessModal(true);
      setForgotPasswordPopup({
        open: false,
        stage: 1,
        username: "",
        verificationCode: "",
        newPassword: "",
        confirmPassword: "",
      });
      triggerSnackbar("Password changed successfully.");
    } catch (error) {
      if (error.code === 429 || error.httpStatus === 429) {
        setErrorMessage("Too many failed attempts. Please request a new OTP.");
        setForgotPasswordPopup({
          open: true,
          stage: 1,
          username: forgotPasswordPopup.username,
          verificationCode: "",
          newPassword: "",
          confirmPassword: "",
        });
      } else {
        setErrorMessage("Failed to reset password.");
      }
    }
  };

  const renderForgotPasswordStage = () => {
    const forgotPasswordButtonStyles = buttonStyles.forgotPasswordButton;

    switch (forgotPasswordPopup.stage) {
      case 1:
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.6vh' }}>
            <TextField
              variant="outlined"
              placeholder="Enter your username"
              value={forgotPasswordPopup.username}
              fullWidth
              onChange={(e) =>
                setForgotPasswordPopup({
                  ...forgotPasswordPopup,
                  username: e.target.value,
                })
              }
              sx={forgotPasswordFieldStyles}
            />
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleForgotPassword}
              sx={forgotPasswordButtonStyles}
            >
              Send Verification Code
            </Button>
          </div>
        );
      case 2:
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.6vh' }}>
            <TextField
              variant="outlined"
              placeholder="Enter verification code"
              value={forgotPasswordPopup.verificationCode}
              fullWidth
              onChange={(e) =>
                setForgotPasswordPopup({
                  ...forgotPasswordPopup,
                  verificationCode: e.target.value,
                })
              }
              sx={forgotPasswordFieldStyles}
            />
            <TextField
              type="password"
              variant="outlined"
              placeholder="Enter new password"
              value={forgotPasswordPopup.newPassword}
              fullWidth
              onChange={(e) =>
                setForgotPasswordPopup({
                  ...forgotPasswordPopup,
                  newPassword: e.target.value,
                })
              }
              sx={forgotPasswordFieldStyles}
            />
            <TextField
              type="password"
              variant="outlined"
              placeholder="Confirm new password"
              value={forgotPasswordPopup.confirmPassword}
              fullWidth
              onChange={(e) =>
                setForgotPasswordPopup({
                  ...forgotPasswordPopup,
                  confirmPassword: e.target.value,
                })
              }
              sx={forgotPasswordFieldStyles}
            />
            {errorMessage && (
              <p style={{ color: '#ff6b6b', fontSize: '1.4vh', margin: '0.8vh 0' }}>
                {errorMessage}
              </p>
            )}
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleResetPassword}
              sx={forgotPasswordButtonStyles}
            >
              Reset Password
            </Button>
          </div>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if (code) {
      localStorage.setItem("accessToken", code);
      // navigate("/home");
      navigate("/shows");
    }
  }, [navigate]);

  const signUp = () => {
    navigate("/signup");
  };


  const closePopup = () => {
    setForgotPasswordPopup({
      ...forgotPasswordPopup,
      open: false,
    });
  };

  return (
    <div className="height-100 clr-white">
      <div className="container-fluid">
        <div className="row theme-bg height-100">
          <div className="col-xl-7 col-lg-6">
            {/* <div className="logo-container">
              <img src={logo} alt="Dyrect Logo" className="logo-image" />
              <span className="logo-text">yrect</span>
            </div> */}
            {/* <div className="welcome-grid height-100">Welcome!</div> */}
           <div className="welcome-grid height-100">
              <div style={{ display: 'flex', alignItems: 'stretch',marginLeft:"15%",gap:"1.6vh" }}>
                <div style={{ position: 'relative', display: 'inline-block'}}>
                  <img src={arrowSignup} alt="Arrow" className="arrow-signup"/>
                  <LogoAnimation />
                </div>
                <h1 className="logo-text-signup">yrect</h1>
            </div>
            </div>            
            <div className="ellipse" />
          </div>
          <div className="col-xl-5 col-lg-6" style={{ zIndex: "1000", marginTop: '5vh' }}>
            <div className="login-grid" style={{ margin: '5vh' }}>
              {!showTOTP && (
                <>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8vh' }}>
                    <h2 className="login-title">Login</h2>
                    <p className="login-subtitle">Glad to have you back!</p>
                  </div>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1.6vh' }}>
                    <FormControl fullWidth>
                      <FormLabel sx={{ color: '#FFFFFF', fontSize: '1.6vh', fontWeight:'100',marginBottom: '0.4vh',marginLeft: '1.6vh' }}>
                        Username
                      </FormLabel>
                      <TextField
                        variant="outlined"
                        placeholder="Enter your username"
                        onChange={(e) => setEmail(e.target.value)}
                        className="input-field"
                        sx={inputFieldStyles}
                      />
                    </FormControl>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8vh' }}>
                    <FormControl fullWidth>
                      <FormLabel sx={{color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100',marginBottom: '0.4vh',marginLeft: '1.6vh'}}>
                        Password
                      </FormLabel>
                      <TextField
                        className="input-field no-autofill-border"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter your password"
                        variant="outlined"
                        onChange={(e) => setPassword(e.target.value)}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                edge="end"
                                sx={{
                                  padding: '0.6vh',
                                }}
                              >
                                {showPassword ? (
                                  <VisibilityOff className="clr-white" sx={{ fontSize: '2vh'}}/>
                                ) : (
                                  <Visibility className="clr-white" sx={{ fontSize: '2vh'}}/>
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        sx={inputFieldStyles}
                      />
                    </FormControl>

                    <FormControlLabel
                      control={
                        <Checkbox
                          sx={{
                            padding: '0.6vh',
                            color: '#fff',
                            '&.Mui-checked': {
                              color: '#fff',
                            },
                            '& svg': {
                              fontSize: '2.4vh',
                            },
                          }}
                        />
                      }
                      label={
                        <span style={{ fontSize: '1.6vh' }}>
                          Remember me
                        </span>
                      }
                      sx={{
                        margin: 0,
                        marginRight: 0,
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%',
                        '& .MuiFormControlLabel-label': {
                          marginLeft: '0.8vh',
                          fontSize: '1.4vh',
                          display: 'flex',
                          alignItems: 'center',
                          height: '100%',
                        },
                      }}
                    />
                    </div>
                  </div>

                </>
              )}
              {showTOTP && (
                <>
                  <h2 className="login-title">Authenticator Code</h2>
                  <FormControl fullWidth sx={{ marginBottom: '0.8vh' }}>
                    <FormLabel sx={{ color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100',marginBottom: '0.4vh',marginLeft: '1.6vh' }}>
                      Verification Code
                    </FormLabel>
                    <TextField
                      placeholder="Enter code from email app"
                      variant="outlined"
                      value={totpCode}
                      onChange={(e) => setTotpCode(e.target.value)}
                      sx={inputFieldStyles}
                    />
                  </FormControl>
                </>
              )}

              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8vh' }}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  className="login-button"
                  onClick={showTOTP ? handleVerifyOTP : handleLogin}
                  disabled={activeButton}
                  sx={buttonStyles.primary}
                >
                  {showTOTP ? "Verify Code" : "Login"}
                </Button>
                <p
                  className="forgot-password pointer links"
                  style={{
                    fontSize: '1.8vh',
                  }}
                  onClick={() =>
                    setForgotPasswordPopup((prev) => ({ ...prev, open: true }))
                  }
                >
                  <a>Forgot password?</a>
                </p>
              </div>

              <div className="or-section">
                <span>Or</span>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8vh', alignItems: 'center' }}>
                <h3 style={{ color: '#ffffff', fontSize: '1.8vh', fontWeight: '100', margin: 0 }}>Login with</h3>
                <div className="social-icons">
                  <IconButton
                    aria-label="Google"
                    className="social-icon google"
                    onClick={handleGoogleLogin}
                  >
                    <img
                      src={faGoogle}
                      alt="Google"
                      style={{ width: "4vh", height: "4vh" }}
                    />
                  </IconButton>
                  <IconButton
                    aria-label="Facebook"
                    className="social-icon facebook"
                    onClick={handleFacebookLogin}
                  >
                    <img
                      src={faFacebook}
                      alt="Facebook"
                      style={{ width: "4vh", height: "4vh" }}
                    />
                  </IconButton>
                  <IconButton
                    aria-label="Apple"
                    className="social-icon apple"
                    onClick={() => alert("Apple clicked")}
                  >
                    <FontAwesomeIcon
                      icon={faApple}
                      style={{ color: "#ffffff", fontSize: "1.5em",width: "4vh", height: "4vh" }}
                    />
                  </IconButton>
                </div>
              </div>

              <p className="signup-text" style={{
                fontSize: '1.8vh',
              }}>
                Don't have an account?{" "}
                <button 
                  className="links" 
                  onClick={signUp}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      signUp();
                    }
                  }}
                  style={{
                    fontSize: '1.8vh',
                    fontWeight: 500,
                    cursor: 'pointer',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                  }}
                  aria-label="Sign up for a new account"
                >
                  Signup
                </button>
              </p>
              <div className="footer-links" style={{
                fontSize: '1.6vh',
              }}>
                <a href="javascript:void(0)">Terms & Conditions</a>{" "}
                <a href="javascript:void(0)">Support</a>{" "}
                <a href="javascript:void(0)">Customer Care</a>
              </div>
            </div>
          </div>
          <div className="bottom-ellipse"></div>
        </div>
        {forgotPasswordPopup.open && (
          <div className="forgot-password-popup-overlay" onClick={closePopup}>
            <div
              className="forgot-password-popup"
              onClick={(e) => e.stopPropagation()}
            >
              <h3>
                {forgotPasswordPopup.stage === 1
                  ? "Forgot Password"
                  : "Reset Password"}
              </h3>
              {renderForgotPasswordStage()}
            </div>
          </div>
        )}

        <ErrorModal
          open={popup.open}
          title={popup.title}
          message={popup.message}
          onClose={handlePopupClose}
        />
      </div>
    </div>
  );
}

export default Login;
